import React, { useState, useCallback } from 'react';
import {
  Modal,
  Fade,
  Typography,
  Box,
  Backdrop,
  Button,
  IconButton,
  TextField,
  MenuItem,
  Autocomplete,
  Accordion,
  AccordionSummary,
  AccordionDetails,
  RadioGroup,
  FormControlLabel,
  InputAdornment,
  ListItemText,
  ListItemIcon,
  Radio,
  Paper,
  CircularProgress,
} from '@mui/material';
import CloseIcon from '@mui/icons-material/Close';
import { useEffect } from 'react';
import { LoadingButton } from '@mui/lab';
import ExpandMoreIcon from '@mui/icons-material/ExpandMore';
import SettingsIcon from '@mui/icons-material/Settings';

import InputField from '../../../components/formElements/InputField';
import { API, graphqlOperation } from 'aws-amplify';
import AddBankAccountModal from './AddBankAccountModal';
import AddNewPartyModal from './AddNewPartyModal';
import { AddBox } from '@mui/icons-material';
import { grey } from '@mui/material/colors';
import AddHSNModal from './AddHSNModal';
import { useDispatch, useSelector } from 'react-redux';
import { showSuccessSnackbar } from '../../../components/snackBar/snakbar';
import { searchHSN } from '../../../graphql';
import {
  useCreateAccountGSTDetailsMutation,
  useCreateAccountMasterMutation,
  useListAccountMasterv2Query,
} from '../../../redux/apis/accountMaster.api';
import { useListGroupMasterQuery } from '../../../redux/apis/accountGroupMaster.api';
import UseHSNMaster from '../Components/UseHSNMaster';
import useSaveModalShortcut from '../Components/useSaveModalShortcut';
import { capitalizeWords } from '../../../utils/common';
import { dashboardApi } from '../../../redux/apis/dashboardApi';
import AddIcon from "@mui/icons-material/Add";
import GroupModal from '../../../features/AccountsAndGroups/components/Groups/GroupModal';

const style = {
  position: 'absolute',
  top: '50%',
  left: '50%',
  transform: 'translate(-50%, -50%)',
  boxShadow: 24,
  // p: 4,
  outline: 'none',
  // minWidth: "500px",
  width: { xs: '80vw', md: '50vw' },
};
const gstOrCompositeRate = [
  { id: -1, rate: 'NIL' },
  { id: 0, rate: '0%' },
  { id: 3, rate: '3%' },
  { id: 5, rate: '5%' },

  { id: 12, rate: '12%' },
  { id: 18, rate: '18%' },
  { id: 28, rate: '28%' },
  { id: 40, rate: '40%' },
];
function AddAccountModal({
  open,
  setOpen,
  setData,
  data,
  accountType,
  Type,
  setAllAccount,
  setNonItemEditedRow,
  companyData,
  setNewPartyID,
  newPartyID,
  setSelectedGroupId,
  selelctedGroupId,
  setNewPartyName,
  newPartyName,
  updatetedTableRow,
  rowIndex,
  listAccounts,
  partyType,
  getAccountGSTDetails,
  accountParamsID,
}) {
  const dispatch = useDispatch();
  let getCompany = useSelector((state) => state?.companyReducer?.companyDetails);
  const companyType = getCompany?.relatedcompanydetailsnew?.[0]?.registrationtype;
  const cessFlag = getCompany?.relatedcompanydetailsnew?.[0]?.gstcompensationcessflag;
  const TaxabilityOptions =
    companyType === 3
      ? [
          { label: 'Composition - Taxable', value: 1 },
          { label: 'Exempted', value: 2 },
          { label: 'Non-Taxable(Non-GST)', value: 3 },
          { label: 'Out of scope', value: 5 },
        ]
      : [
          { label: 'Taxable', value: 1 },
          { label: 'Exempted', value: 2 },
          { label: 'Non-Taxable(Non-GST)', value: 3 },
          { label: 'GST Reverse Charge', value: 4 },
          { label: 'Out of scope', value: 5 },
        ];
  const [ledger, setLedger] = useState([]);
  const [group, setGroup] = useState([]);
  const [enableCess, setEnableCess] = useState(false);
  const [loading, setLoading] = useState(false);
  const [accountTypeCD, setAccountTypeCD] = useState('');
  const [openBankAccountModal, setOpenBankAccountModal] = useState(false);
  const [openPartyModal, setOpenPartyModal] = useState(false);
  const [openGroupModal,setOpenGroupModal]=useState(false);
  const [state, setState] = useState({
    group: { label: '', value: '', path: '' },
    name: '',
    hsnCode: { label: '', value: '' },
    taxability: { label: '', value: '' },
    gstrate: '',
    cess: '',
    cessType: 'Amount',
    errorStatus: {
      group: false,
      name: false,
      hsnCode: false,
      gstrate: false,
      cess: false,
      cessType: false,
    },
    errorFields: {
      group: '',
      name: '',
    },
  });
  const [openHsnModal, setOpenHsnModal] = useState(false);
  const [hsnParamsID, setHSNParamsID] = useState('');

  const companyDetails = useSelector((state) => state?.companyReducer?.companyDetails);
  const compositePercent = companyDetails?.relatedcompanydetailsnew?.[0]?.comppercentage;
  const { filterHSN, setFilterHSN, searchHSNDetails, HSNListboxProps, setRow } = UseHSNMaster({ Type: '', Page: 'NONITEM' });
  const handleClose = (event, reason) => {
    setState((prev) => ({
      ...prev,
      name: '',
      group: { label: '', value: '', path: '' },
      hsnCode: { label: '', value: '' },
      taxability: { label: '', value: '' },
      gstrate: '',
      cess: '',
      cessType: 'Amount',
      errorStatus: {
        ...prev.errorStatus,
        name: false,
        group: false,
        hsnCode: false,
        gstrate: false,
        cess: false,
        cessType: false,
      },
      errorFields: {
        ...prev.errorFields,
        name: '',
        group: '',
        hsnCode: '',
        gstrate: '',
        cess: '',
        cessType: '',
      },
    }));
    setOpen(false);
  };
  const [
    createAccountMaster,
    { isLoading: isCreatingAccount, isError: isCreateAccountError, isSuccess: isCreateAccountSuccess, error: createAccountError },
  ] = useCreateAccountMasterMutation();

  function formValidation(data) {
    let isvalid = true;
    let obj = { ...state };

    Object.keys(data).map((key) => {
      if (key === 'name') {
        if (data[key].trim().length <= 0) {
          isvalid = false;
          obj.errorFields.name = 'Account Name is required';
          obj.errorStatus.name = true;
        } else {
          let uniqueValid = true;
          ledger.map((item) => {
            if (item.accountname.toLowerCase() == state.name.toLowerCase()) {
              uniqueValid = false;
            }
          });
          if (uniqueValid == false) {
            isvalid = false;
            obj.errorFields.name = 'Account Name already exists';
            obj.errorStatus.name = true;
          } else {
            obj.errorFields.name = '';
            obj.errorStatus.name = false;
          }
        }
      }
      if (key === 'group') {
        if (data[key].value == 0) {
          isvalid = false;
          obj.errorFields.group = 'Group is required';
          obj.errorStatus.group = true;
        } else {
          obj.errorFields.group = '';
          obj.errorStatus.group = false;
        }
      }
      if (companyType !== 3 && companyType !== 1 && partyType==="CUSTOMER") {
        if (key === 'hsnCode') {
          if (data[key].value == 0 || data[key].value === '') {
            isvalid = false;
            obj.errorFields.hsnCode = 'HSN/SAC Code is required';
            obj.errorStatus.hsnCode = true;
          } else {
            obj.errorFields.hsnCode = '';
            obj.errorStatus.hsnCode = false;
          }
        }
      }
    });
    setState(obj);
    return isvalid;
  }

  // function comparePathWithId(pathString, ...ids) {
  //   const pathArray = pathString?.replace(/^\/|\/$/g, "").split("/");
  //   const pathWithoutAccountId = pathArray?.slice(0, -1);

  //   return ids.some((id) => pathWithoutAccountId?.includes(id.toString()));
  // }
  function handleGroupChanges(newValue){
   if (newValue?.value !== "add_new") {
  if (!newValue) {
    setState((prev) => ({
      ...prev,
      group: newValue,
      errorStatus: { ...prev.errorStatus, group: true },
      errorFields: { ...prev.errorFields, group: "Group Field is required" },
    }));
    return;
  }
  setState((prev) => ({
    ...prev,
    group: newValue,
    errorStatus: { ...prev.errorStatus, group: false },
    errorFields: { ...prev.errorFields, group: "" },
  }));

  let typeCD = "";
  group.forEach((ele) => {
    if (ele.value === newValue.value) typeCD = ele.accountTypeCD;
  });

  if (newValue.value === 17 || newValue.value === 29) {
    setOpenBankAccountModal(true);
    setOpen(false);
  }

  if (comparePathWithId(newValue.path, 18, 22, 24) && cessFlag !== 1) {
    setEnableCess(true);
  } else {
    setEnableCess(false);
  }

  if (comparePathWithId(newValue.path, 15)) {
    setSelectedGroupId(15);
    setNewPartyName(state.name);
    setOpenPartyModal(true);
    handleClose();
  }

  if (comparePathWithId(newValue.path, 7)) {
    setSelectedGroupId(7);
    setNewPartyName(state.name);
    setOpenPartyModal(true);
    handleClose();
  }

  setAccountTypeCD(typeCD);
}
  }
  function comparePathWithId(pathString, ...ids) {
    const pathArray = pathString?.replace(/^\/|\/$/g, '').split('/');
    return ids.some((id) => pathArray?.includes(id.toString()));
  }

  const { data: groupsList, isLoading: isGroupLoading, isError } = useListGroupMasterQuery();

  const { data: ledgerList } = useListAccountMasterv2Query();
  async function listLedgerData() {
    try {
      let allAccount = [];
      let expenceAccArr = [];
      // const res = await API.graphql(
      //   graphqlOperation(listAccountMasterv2Custom)
      // );
      let res = { data: { listAccountMasterv2: ledgerList } };
      if (res.data.listAccountMasterv2 !== null) {
        setLedger(res.data.listAccountMasterv2);
        const filteredAllAccArray = res.data.listAccountMasterv2.filter((item) => {
          return ![16, 17, 19, 21].includes(item.path);
        });
        filteredAllAccArray.map((ele) => {
          let groupName = ele.accountgroupname?.replace(/([a-z])([A-Z])/g, '$1 $2')?.trim();
          if (Type === 'Journal' && accountType === 'ledgerAccount') {
            if (ele.accountsid !== 24 && ele.accountsid !== 23) {
              allAccount.push({
                label: ele.accountname,
                value: ele.accountsid,
                AccountGroupID: ele?.accountgroupid,
                Is_Active: ele.is_active,
                groupName,
                AccountTypeFlag: ele.accounttypeflag,
                TDSSection: ele.tdssection,
                TDSPercentage: ele.tdspercentage,
              });
            }
          } else {
            allAccount.push({
              label: ele.accountname,
              value: ele.accountsid,
              groupName,
              AccountTypeFlag: ele.accounttypeflag,
              AccountGroupID: ele?.accountgroupid,
              TDSSection: ele.tdssection,
              TDSPercentage: ele.tdspercentage,
            });
          }
        });
        if (setAllAccount) {
          setAllAccount(allAccount);
        }
        if ((Type === 'Sales' || Type === 'Pos') && accountType === 'ledgerAccount') {
          const filteredcArray = res.data.listAccountMasterv2.filter((item) => {
            // return comparePathWithId(item.path, 18, 24, 29);
            return comparePathWithId(item.path, 19, 22);
          });
          filteredcArray.map((ele) => {
            let groupName = ele.accountgroupname?.replace(/([a-z])([A-Z])/g, '$1 $2')?.trim;

            expenceAccArr.push({
              label: ele.accountname,
              value: ele.accountsid,
              groupName,
              AccountTypeFlag: ele.accounttypeflag,
              AccountGroupID: ele?.accountgroupid,
              TDSSection: ele.tdssection,
              TDSPercentage: ele.tdspercentage,
            });
          });
        }
        if (Type === 'Purchase' && accountType === 'ledgerAccount') {
          const filteredcArray = res.data.listAccountMasterv2.filter((item) => {
            // return comparePathWithId(item.path, 20, 25);
            return comparePathWithId(item.path, 21, 23);
          });
          filteredcArray?.map((ele) => {
            let groupName = ele.accountgroupname?.replace(/([a-z])([A-Z])/g, '$1 $2')?.trim();
            expenceAccArr.push({
              label: ele.accountname,
              value: ele.accountsid,
              groupName,
              AccountTypeFlag: ele.accounttypeflag,
              AccountGroupID: ele?.accountgroupid,
              TDSSection: ele.tdssection,
              TDSPercentage: ele.tdspercentage,
            });
          });
        }

        // if (
        //   Type === "Sales" ||
        //   Type === "Pos" ||
        //   Type === "Purchase" ||
        //   Type === "CreditNote" ||
        //   Type === "DebitNote"
        // ) {
        //   setExpenceAccNames(expenceAccArr);
        // }
        let partyName = { label: '', value: '' };

        if (newPartyID !== '' && newPartyID !== undefined && newPartyID !== null) {
          allAccount.map((ele) => {
            if (ele.label === newPartyName) {
              partyName = {
                label: ele.label,
                value: ele.value,
                AccountTypeFlag: ele.AccountTypeFlag,
                groupName: ele.groupName,
                TDSSection: ele.TDSSection,
                TDSPercentage: ele.TDSPercentage,
              };
            }
          });

          if (Type === 'Payment') {
            let amount = Number(((Number(data.payableAmount) / 100) * partyName.TDSPercentage).toFixed(2));
            setData((prev) => ({
              ...prev,
              paidTo: partyName,
              tdsApplicable: partyName.TDSSection,
              TDSPercentage: partyName.TDSPercentage,
              tdsAmount: amount,
              TDSManual: 0,
            }));
          }
          if (Type === 'Receipt') {
            let amount = Number(((Number(data.receivableAmount) / 100) * partyName.TDSPercentage).toFixed(2));
            setData((prev) => ({
              ...prev,
              receivedFrom: partyName,
              tdsApplicable: partyName.TDSSection,
              TDSPercentage: partyName.TDSPercentage,
              tdsAmount: amount,
              TDSManual: 0,
            }));
          }
          if (Type === 'Sales' || Type === 'Purchase' || Type === 'CreditNote' || Type === 'DebitNote') {
            updatetedTableRow[rowIndex] = {
              ...updatetedTableRow[rowIndex],
              ledgerAccount: partyName,
            };
            setNonItemEditedRow(updatetedTableRow);
          }
          if (Type === 'Journal') {
            updatetedTableRow[rowIndex] = {
              ...updatetedTableRow[rowIndex],
              ledgerAccount: partyName,
              currentBalance: 0,
            };
            setNonItemEditedRow(updatetedTableRow);
          }

          handleClose();
        }
      }
    } catch (error) {
      console.log('error', error);
    }
  }

  async function listGroup() {
    if (groupsList?.length > 0) {
      let allAccounts = [];
      groupsList?.forEach((ele) => {
        let groupName = ele.accountgroupname?.replace(/([a-z])([A-Z])/g, '$1 $2')?.trim();

        // Exclude specific account group IDs when companyType is 1
        if (companyType == 1 && [8, 31, 32, 33].some((id) => ele.path.includes(`/${id}/`))) {
          return;
        }

        if (Type === 'Journal' && accountType === 'ledgerAccount') {
          if (![16, 17, 19, 21, 29].some((id) => ele.path.includes(`/${id}/`))) {
            allAccounts.push({
              label: ele.accountgroupname,
              value: ele.accountgroupid,
              accountTypeCD: ele.accounttypecd,
              path: ele?.path,
              groupName,
            });
          }
        } else if (['DebitNote', 'CreditNote', 'Sales', 'Purchase'].includes(Type) && accountType === 'ledgerAccount') {
          if (![7, 15, 17, 29, 16].some((id) => ele.path.includes(`/${id}/`))) {
            allAccounts.push({
              label: ele.accountgroupname,
              value: ele.accountgroupid,
              accountTypeCD: ele.accounttypecd,
              path: ele?.path,
              groupName,
            });
          }
        } else {
          if (accountType === 'Bank') {
            if ([17, 29].some((id) => ele.path.includes(`/${id}/`))) {
              allAccounts.push({
                label: ele.accountgroupname,
                value: ele.accountgroupid,
                accountTypeCD: ele.accounttypecd,
                path: ele?.path,
                groupName,
              });
            }
          } else {
            allAccounts.push({
              label: ele.accountgroupname,
              value: ele.accountgroupid,
              accountTypeCD: ele.accounttypecd,
              path: ele?.path,
              groupName,
            });
          }
        }
      });

      if (accountType === 'Cash') {
        setState((prev) => ({
          ...prev,
          group: { label: 'Cash in Hand', value: 16, accountType },
        }));
        setAccountTypeCD('BS');
      }
      if (accountType === 'Bank') {
        setState((prev) => ({
          ...prev,
          group: { label: 'Bank Accounts', value: 17 },
        }));
        setAccountTypeCD('BS');
      }

      allAccounts.sort((a, b) => a.label.localeCompare(b.label));

      setGroup(allAccounts);
    }
  }

  async function searchSACItem(value, limit) {
    try {
      const res = await API.graphql(
        graphqlOperation(searchHSN, {
          rowfrom: 0,
          limitno: limit !== undefined ? limit : 10000,
          word: value,
        })
      );
      let hsnObj = { label: '', value: '' };
      let arr = [];

      if (res.data.searchHSN !== null) {
        await Promise.all(
          res.data.searchHSN.map((item) => {
            arr.push({
              label: `${item.hsnsaccode} - ${item.description}`,
              value: `${item.hsnsaccode}`,
            });
            if (Number(item.hsnsaccode) === Number(value)) {
              hsnObj = {
                label: `${item.hsnsaccode} - ${item.description}`,
                value: `${item.hsnsaccode}`,
              };
            }
          })
        );
      }
      if (hsnObj.label === '' && value !== 0) {
        hsnObj = {
          label: value,
          value: value,
        };
      }
      setFilterHSN(arr);
      return { hsnObj, arr };
    } catch (error) {
      console.log(error);
    }
  }

  useEffect(() => {
    if (open && filterHSN.length == 0) searchSACItem(0, 10);
  }, [open]);
  async function saveChanges() {
    const { group, name, hsnCode } = state;
    const formData = {
      group,
      name,
      hsnCode,
    };
    if (formValidation(formData)) {
      setLoading(true);
      const LedgerData = {
        accountgroupid: group.value,
        accountname: name,
        accounttypecd: accountTypeCD,
        hsnsaccode: state.hsnCode.value == '' ? 0 : Number(state.hsnCode.value),
      };
      if (accountType === 'Bank') {
        setOpenBankAccountModal(true);
      } else {
        saveNewAccounts(LedgerData);
      }
    }
  }

  async function saveNewAccounts(data) {
    try {
      const resledger = await createAccountMaster({
        createAccountMasterInput: data,
      });

      if (resledger.data !== '') {
        if (accountType == 'Cash' || accountType == 'Bank') {
          setData((prev) => ({
            ...prev,
            receivedAccount: {
              label: resledger.data.accountname,
              value: resledger.data.accountsid,
            },
          }));
        }
        if (accountType === 'ledgerAccount') {
          if (Type === 'Purchase' || Type === 'Sales' || Type === 'CreditNote' || Type === 'DebitNote') {
            updatetedTableRow[rowIndex] = {
              ...updatetedTableRow[rowIndex],
              ledgerAccount: {
                label: resledger.data.accountname,
                value: resledger.data.accountsid,
              },
            };
            if (partyType) {
              if (companyType === 3 && partyType === 'CUSTOMER') {
                updatetedTableRow[rowIndex] = {
                  ...updatetedTableRow[rowIndex],
                  GSTRate: compositePercent,
                };
              }
            }

            setData(updatetedTableRow);
          }
          if (Type === 'Journal') {
            updatetedTableRow[rowIndex] = {
              ...updatetedTableRow[rowIndex],
              ledgerAccount: {
                label: resledger.data.accountname,
                value: resledger.data.accountsid,
              },
              currentBalance: 0,
            };
            setData(updatetedTableRow);
          }
        }
        if (Type === 'Payment') {
          if (accountType === 'Cash') {
            setData((prev) => ({
              ...prev,
              paidFrom: {
                label: resledger.data.accountname,
                value: resledger.data.accountsid,
              },
              erroStatus: { ...prev.errorStatus, paidFrom: false },
              errorFields: { ...prev.errorFields, paidFrom: '' },
            }));
          } else {
            setData((prev) => ({
              ...prev,
              paidTo: {
                label: resledger.data.accountname,
                value: resledger.data.accountsid,
              },
              TDSPercentage: 0,
              TDSManual: 0,
              tdsApplicable: '',
              tdsAmount: 0,
              tdsflag: false,
              erroStatus: { ...prev.errorStatus, paidTo: false },
              errorFields: { ...prev.errorFields, paidTo: '' },
            }));
          }
        }
        if (Type === 'Receipt') {
          if (accountType === 'Cash') {
            setData((prev) => ({
              ...prev,
              receivedTo: {
                label: resledger.data.accountname,
                value: resledger.data.accountsid,
              },

              erroStatus: { ...prev.errorStatus, receivedTo: false },
              errorFields: { ...prev.errorFields, receivedTo: '' },
            }));
          } else {
            setData((prev) => ({
              ...prev,
              receivedFrom: {
                label: resledger.data.accountname,
                value: resledger.data.accountsid,
              },
              TDSPercentage: 0,
              TDSManual: 0,
              tdsApplicable: '',
              tdsflag: false,
              tdsAmount: 0,
              erroStatus: { ...prev.errorStatus, receivedFrom: false },
              errorFields: { ...prev.errorFields, receivedFrom: '' },
            }));
          }
        }

        if (accountType !== 'Cash' || accountType !== 'Bank') {
          saveGstDetails(resledger.data.accountsid, resledger.data.accountname);
        }
        if (listAccounts) {
          listAccounts();
        }
        dispatch(dashboardApi.util.invalidateTags(['dashboard']));
        showSuccessSnackbar('Account created Successfully');
        handleClose();
        setLoading(false);
        setOpen(false);
      }
    } catch (error) {
      setLoading(false);
      console.log(error);
    }
  }

  const [createAccountGSTDetails] = useCreateAccountGSTDetailsMutation();

  async function saveGstDetails(accID, ledgerName) {
    try {
      const gstData = {
        accountid: accID,
        effectivedate: Math.floor(new Date().getTime() / 1000),
        expireddate: 0,
        gstcompensationtype: state.cessType,
        gstrate: Number(state.gstrate),
        hsnid: String(state.hsnCode.value == '' ? 0 : String(state.hsnCode.value)),
        cessamount: state.cess == '' ? 0 : Number(state.cess),
        taxability: String(state?.taxability?.value ?? ''),
      };
      const resGstData = await createAccountGSTDetails({
        createAccountGSTDetailsInput: gstData,
      });
      let newValue = { label: ledgerName, value: accID };
      if (resGstData.data !== null) {
        if (accountType === 'ledgerAccount') {
          if (getAccountGSTDetails) {
            getAccountGSTDetails(newValue, rowIndex);
          }
          //   let hsnCode = {
          //     label: "",
          //     value: "",
          //     companyID: "",
          //     hsnID: "",
          //     codeType: "",
          //     description: "",
          //   };

          //   if (resGstData?.data?.hsnsaccode != 0) {
          //     hsnCode = {
          //       label: `${resGstData?.data?.hsnsaccode} - ${resGstData?.data?.description}`,
          //       value: `${resGstData?.data?.hsnsaccode}`,
          //       companyID: resGstData?.data?.companyid,
          //       hsnID: resGstData?.data?.hsnid,
          //       codeType: resGstData?.data?.codetype,
          //       description: resGstData?.data?.description,
          //     };
          //   }

          //   updatetedTableRow[rowIndex] = {
          //     ...updatetedTableRow[rowIndex],
          //     GSTRate:partyType && companyType===3 && partyType==="CUSTOMER"?compositePercent: resGstData?.data?.gstrate,
          //     GSTCess:partyType && companyType===3 && partyType==="CUSTOMER"?0: resGstData?.data?.cessamount,
          //     HSN: hsnCode,
          //   };
          //   setNonItemEditedRow(updatetedTableRow);
          // }
        }
      }
    } catch (error) {
      console.log(error);
    }
  }

  useEffect(() => {
    if (open) {
      listGroup();
    }
  }, [groupsList, open]);

  useEffect(() => {
    listLedgerData();
  }, [newPartyID, ledgerList]);

  useSaveModalShortcut(() => {
    if (open) {
      saveChanges();
    }
  });

  return (
    <Box id={open ? 'AddLedger' : ''}>
      <Modal
        aria-labelledby="transition-modal-title"
        aria-describedby="transition-modal-description"
        open={open}
        closeAfterTransition
        BackdropComponent={Backdrop}
        BackdropProps={{
          timeout: 500,
        }}
        onClose={handleClose}
      >
        <Fade in={open}>
          <Paper sx={style}>
            <Backdrop sx={{ color: '#fff', zIndex: (theme) => theme.zIndex.drawer + 1 }} open={isGroupLoading}>
              <CircularProgress color="inherit" />
            </Backdrop>
            <Box
              sx={{
                backgroundColor: 'primary.main',
                padding: '5px 15px',
                display: 'flex',
                flexDirection: 'row',
              }}
            >
              <Box sx={{ flex: 1 }}>
                <Typography
                  sx={{
                    color: '#fff',
                    display: 'flex',
                    justifyContent: 'space-between',
                    alignItems: 'center',
                  }}
                >
                  Add New Account
                  <IconButton aria-label="delete" onClick={handleClose}>
                    <CloseIcon sx={{ color: '#fff' }} />
                  </IconButton>
                </Typography>
              </Box>
            </Box>

            <Box
              sx={{
                padding: '15px',
              }}
            >
              <Box
                sx={{
                  display: 'flex',
                }}
              >
                <Box sx={{ flex: { xs: 1, sm: 0.5 }, m: 1 }}>
                  <InputField
                    required={true}
                    state={state}
                    name="name"
                    placeholder="Account"
                    size="small"
                    accountType="text"
                    value={state.name}
                    maxLength={50}
                    onBlur={(e) => {
                      setState((prev) => ({
                        ...prev,
                        name: prev.name?.replace(/\s+/g, ' ')?.trim(),
                      }));
                    }}
                    onChange={(e) => {
                      const { value } = e.target;
                      const trimmedValue = capitalizeWords(value.trimStart());
                      const nameRegex = /^.*$/;

                      if (trimmedValue === '') {
                        // Empty value case
                        setState((prev) => ({
                          ...prev,
                          name: '',
                          errorFields: {
                            ...prev.errorFields,
                            name: 'Account Name is required',
                          },
                          errorStatus: {
                            ...prev.errorStatus,
                            name: true,
                          },
                        }));
                      } else if (!nameRegex.test(trimmedValue)) {
                        // Invalid characters
                        setState((prev) => ({
                          ...prev,
                          name: trimmedValue,
                          errorFields: {
                            ...prev.errorFields,
                            name: 'Invalid Account Name',
                          },
                          errorStatus: {
                            ...prev.errorStatus,
                            name: true,
                          },
                        }));
                      } else {
                        const capitalizedValue = trimmedValue
                          .split(/\s+/)
                          .map((word) => word.charAt(0).toUpperCase() + word.slice(1))
                          .join(' ');

                        const exists = ledger.some((item) => item.accountname?.toLowerCase() === capitalizedValue.toLowerCase());

                        if (exists) {
                          setState((prev) => ({
                            ...prev,
                            name: capitalizedValue,
                            errorFields: {
                              ...prev.errorFields,
                              name: 'Account Name already exists',
                            },
                            errorStatus: {
                              ...prev.errorStatus,
                              name: true,
                            },
                          }));
                        } else {
                          setState((prev) => ({
                            ...prev,
                            name: capitalizedValue,
                            errorFields: {
                              ...prev.errorFields,
                              name: '',
                            },
                            errorStatus: {
                              ...prev.errorStatus,
                              name: false,
                            },
                          }));
                        }
                      }
                    }}
                  />
                </Box>
                <Box sx={{ flex: { xs: 1, sm: 0.5 }, m: 1 }}>
                 <Autocomplete
  disablePortal
  id="group"
  disableClearable
  disabled={state.name === "" || accountType === "Cash"}
  options={[{ label: "Add New Group", value: "add_new" }, ...group]} // prepend option
  isOptionEqualToValue={(option, value) => option.value === value.value}
  value={state.group}
  onChange={(e, newValue) => {
     if (newValue?.value === "add_new") {
    e.stopPropagation(); 
    setOpenGroupModal(true); 
    return;
  }
 handleGroupChanges(newValue);
}}

  size="small"
  renderOption={(props, option) =>
    option.value === "add_new" ? (
      <MenuItem {...props}>
        <ListItemIcon  sx={{ color: 'primary.main' }}>
          <AddBox fontSize="small" />
        </ListItemIcon>
        <ListItemText  sx={{ color: 'primary.main' }} primary="Add New Group" />
      </MenuItem>
    ) : (
      <MenuItem {...props}>{option.label}</MenuItem>
    )
  }
  renderInput={(params) => (
    <TextField
      {...params}
      label="Group"
      error={state.errorStatus.group}
      InputLabelProps={{ shrink: true }}
      sx={{
        ".css-1n4twyu-MuiInputBase-input-MuiOutlinedInput-input": {
          padding: "8.5px 7px",
        },
        label: { fontSize: "14px" },
      }}
    />
  )}
/>
                  <Typography
                    sx={{
                      marginTop: '2px',
                      marginLeft: '10px',
                      marginBottom: '0px',
                      fontSize: '11px',
                      color: 'danger.main',
                    }}
                  >
                    {state?.errorFields.group}
                  </Typography>
                </Box>
              </Box>

              {/* {state.group.value !== 17 && state.group.value !== 16 && ( */}
              {data?.paymentType !== 'Cash' &&
                data?.paymentType !== 'Bank' &&
                companyDetails?.relatedcompanydetailsnew?.[0]?.registrationtype !== 1 && (
                  <Accordion sx={{ mt: 2 }} defaultExpanded>
                    <AccordionSummary
                      expandIcon={<ExpandMoreIcon />}
                      aria-controls="panel1a-content"
                      id="panel1a-header"
                      sx={{ maxHeight: 'auto' }}
                    >
                      <Typography sx={{ color: 'primary.main', fontWeight: '500' }}>GST Details</Typography>
                    </AccordionSummary>
                    <AccordionDetails>
                      <Box sx={{ display: 'flex' }}>
                        <Box
                          sx={{
                            flex: { xs: 1, sm: 0.5 },
                            m: 1,
                            minWidth: '10px',
                          }}
                        >
                          <Autocomplete
                            openOnFocus
                            error={state.errorStatus.hsnCode === true ? true : false}
                            disablePortal
                            id="HSN/SAC CODE"
                            name="hsnCode"
                            placeholder="HSN/SAC Code"
                            disableClearable
                            options={['Add HSN/SAC Code', ...filterHSN]}
                            isOptionEqualToValue={(option, value) => option.value == value.value}
                            renderOption={(props, option) => (
                              <>
                                {option === 'Add HSN/SAC Code' ? (
                                  <MenuItem
                                    value={'addHsn'}
                                    onClick={(event) => {
                                      event.stopPropagation();
                                      event.preventDefault();
                                      setOpenHsnModal(true);
                                      setHSNParamsID('');
                                    }}
                                    sx={{
                                      display: 'flex',
                                      alignItems: 'center',
                                      position: 'fixed',
                                      width: '100%',
                                      top: '0px',
                                      backgroundColor: grey[50],
                                      '&:hover': {
                                        backgroundColor: grey[200],
                                      },
                                    }}
                                  >
                                    <AddBox
                                      fontSize="small"
                                      sx={{
                                        marginRight: '5px',
                                        color: 'primary.main',
                                      }}
                                    />
                                    <ListItemText sx={{ color: 'primary.main' }} primary={'Add HSN/SAC Code'} />
                                  </MenuItem>
                                ) : (
                                  <li {...props}>{option.label}</li>
                                  // <MenuItem
                                  //   {...props}
                                  //   key={option.value}
                                  //   value={option.value}
                                  // >
                                  //   <ListItemText primary={option.label} />
                                  // </MenuItem>
                                )}
                              </>
                            )}
                            value={state.hsnCode}
                            onChange={(e, newValue) => {
                              if (newValue == '' && partyType==="CUSTOMER") {
                                setState((prev) => ({
                                  ...prev,
                                  hsnCode: newValue,
                                  errorStatus: {
                                    ...prev.errorStatus,
                                    hsnCode: true,
                                  },
                                  errorFields: {
                                    ...prev.errorFields,
                                    hsnCode: 'HSN/SAC Code is required',
                                  },
                                }));
                              } else {
                                setState((prev) => ({
                                  ...prev,
                                  hsnCode: newValue,
                                  errorStatus: {
                                    ...prev.errorStatus,
                                    hsnCode: false,
                                  },
                                  errorFields: {
                                    ...prev.errorFields,
                                    hsnCode: '',
                                  },
                                }));
                              }
                            }}
                            sx={{
                              '.css-1kxbtff-MuiAutocomplete-root .MuiOutlinedInput-root.MuiInputBase-sizeSmall': {
                                paddingBottom: '5px',
                              },
                              '.css-lcu7oo-MuiAutocomplete-root .MuiOutlinedInput-root.MuiInputBase-sizeSmall': {
                                paddingTop: '6px',
                                paddingBottom: '5px',
                                paddingLeft: '6px',
                              },
                            }}
                            onInputChange={(e, newValue) => {
                              setRow(0);
                              if (newValue) {
                                searchHSNDetails(newValue, 0, 20);
                              } else {
                                searchHSNDetails('', 0, 20);
                              }
                            }}
                            ListboxProps={HSNListboxProps}
                            size="small"
                            renderInput={(params) => (
                              <TextField
                                error={state.errorStatus.hsnCode === true ? true : false}
                                required={companyType != 3 && partyType==="CUSTOMER" ? true : false}
                                sx={{
                                  '.css-1n4twyu-MuiInputBase-input-MuiOutlinedInput-input': {
                                    padding: '8.5px 7px',
                                  },
                                  '.css-l2dxek-MuiInputBase-root-MuiOutlinedInput-root': {
                                    fontSize: '14px',
                                  },
                                  label: {
                                    fontSize: '14px',
                                  },
                                  '.css-lnk63-MuiButtonBase-root-MuiMenuItem-root': {
                                    fontSize: '14px',
                                  },
                                  '.css-1atz3nw-MuiFormLabel-root-MuiInputLabel-root': {
                                    color: 'input.font',
                                  },
                                  '.css-1d3z3hw-MuiOutlinedInput-notchedOutline': {
                                    borderColor: 'input.border',
                                  },
                                  '.css-1jiigs4-MuiFormLabel-root-MuiInputLabel-root': {
                                    color: 'input.font',
                                  },
                                  '.css-14qz1ij-MuiListItemText-root': {
                                    margin: '0px',
                                  },
                                  '.css-wgai2y-MuiFormLabel-asterisk': {
                                    color: 'danger.main',
                                  },
                                }}
                                InputLabelProps={{
                                  shrink: true,
                                }}
                                {...params}
                                label="HSN/SAC Code"
                              />
                            )}
                          />
                          {state.errorStatus.hsnCode !== true ? (
                            <Typography
                              sx={{
                                marginTop: '2px',
                                marginLeft: '10px',
                                marginBottom: '0px',
                                fontSize: '11px',
                                color: 'primary.main',
                              }}
                            >
                              Use atleast 3 characters
                            </Typography>
                          ) : (
                            <Typography
                              sx={{
                                marginTop: '2px',
                                marginLeft: '10px',
                                marginBottom: '0px',
                                fontSize: '11px',
                                color: 'danger.main',
                              }}
                            >
                              {state?.errorFields.hsnCode}
                            </Typography>
                          )}
                        </Box>
                        <Box
                          sx={{
                            flex: { xs: 1, sm: 0.5 },
                            m: 1,
                            minWidth: '10px',
                          }}
                        >
                          <Autocomplete
                            openOnFocus
                            error={state.errorStatus.taxability === true ? true : false}
                            disablePortal
                            id="Taxability"
                            name="taxability"
                            placeholder="Taxability"
                            disableClearable
                            options={TaxabilityOptions}
                            value={state?.taxability}
                            isOptionEqualToValue={(option, value) => option.value == value.value}
                            size="small"
                            onChange={(e, newValue) => {
                              if (newValue === '') {
                                setState((prev) => ({
                                  ...prev,
                                  errorStatus: {
                                    ...prev.errorStatus,
                                    taxability: true,
                                  },
                                  errorFields: {
                                    ...prev.errorFields,
                                    taxability: 'Taxability  is required',
                                  },
                                }));
                              } else {
                                setState((prev) => ({
                                  ...prev,
                                  taxability: newValue,
                                  errorStatus: {
                                    ...prev.errorStatus,
                                    taxability: false,
                                  },
                                  errorFields: {
                                    ...prev.errorFields,
                                    taxability: '',
                                  },
                                }));
                              }
                            }}
                            renderInput={(params) => (
                              <TextField
                                error={state?.errorStatus?.taxability === true ? true : false}
                                required={false}
                                label="Taxability"
                                sx={{
                                  '.MuiFormLabel-asterisk': {
                                    color: 'danger.main',
                                    fontSize: '16px',
                                    fontWeight: 'bold',
                                  },
                                }}
                                InputLabelProps={{
                                  shrink: true,
                                }}
                                {...params}
                              />
                            )}
                          />
                        </Box>
                      </Box>
                      {![2, 3, 4].includes(state?.taxability.value) && (
                        <Box sx={{ display: 'flex' }}>
                          <Box sx={{ flex: { xs: 1, sm: 0.5, lg: 0.3 }, m: 1 }}>
                            <TextField
                              error={state.errorStatus.gstrate === true ? true : false}
                              select
                              name="gstrate"
                              label="GST Rate"
                              variant="outlined"
                              size="small"
                              fullWidth
                              value={state.gstrate}
                              onChange={(e) => {
                                const name = e.target.name;
                                const value = e.target.value;

                                if (value != 'addgstrate') {
                                  if (value === '') {
                                    setState((prev) => ({
                                      ...prev,
                                      gstrate: value,
                                      errorStatus: {
                                        ...prev.errorStatus,
                                        gstrate: true,
                                      },
                                      errorFields: {
                                        ...prev.errorFields,
                                        gstrate: 'GST Rate is required',
                                      },
                                    }));
                                  } else {
                                    setState((prev) => ({
                                      ...prev,
                                      gstrate: value,
                                      errorStatus: {
                                        ...prev.errorStatus,
                                        gstrate: false,
                                      },
                                      errorFields: {
                                        ...prev.errorFields,
                                        gstrate: '',
                                      },
                                    }));
                                  }
                                }
                              }}
                              sx={{
                                '.css-l2dxek-MuiInputBase-root-MuiOutlinedInput-root': {
                                  fontSize: '14px',
                                },
                                label: {
                                  fontSize: '14px',
                                },
                                '.css-lnk63-MuiButtonBase-root-MuiMenuItem-root': {
                                  fontSize: '14px',
                                },
                                '.css-1atz3nw-MuiFormLabel-root-MuiInputLabel-root': {
                                  color: 'input.font',
                                },
                                '.css-1d3z3hw-MuiOutlinedInput-notchedOutline': {
                                  borderColor: 'input.border',
                                },
                                '.css-1jiigs4-MuiFormLabel-root-MuiInputLabel-root': {
                                  color: 'input.font',
                                },
                                '.css-wgai2y-MuiFormLabel-asterisk': {
                                  color: 'danger.main',
                                },
                              }}
                              InputLabelProps={{
                                shrink: true,
                              }}
                            >
                              {gstOrCompositeRate?.map((item, ind) => {
                                return (
                                  <MenuItem key={item.id} value={`${item.id}`}>
                                    <ListItemText sx={{ margin: '0px' }} primary={item.rate} />
                                  </MenuItem>
                                );
                              })}
                              <MenuItem value={'addgstrate'}>
                                <SettingsIcon fontSize="small" sx={{ marginRight: '5px' }} />
                                <ListItemText primary={'Add GST Rate'} />
                              </MenuItem>
                            </TextField>
                            <Typography
                              sx={{
                                marginTop: '2px',
                                marginLeft: '10px',
                                marginBottom: '0px',
                                fontSize: '11px',
                                color: 'danger.main',
                              }}
                            >
                              {state?.errorFields.gstrate}
                            </Typography>
                          </Box>
                          {enableCess === false && (
                            <>
                              <Box sx={{ flex: { xs: 1, sm: 0.5, g: 1 }, m: 1 }}>
                                <Box
                                  sx={{
                                    position: 'relative',
                                    border: 'solid 1px',
                                    borderColor: state.errorStatus.cessType ? 'danger.main' : 'input.border',
                                    borderRadius: '4px',
                                    padding: '10px 14px',
                                    display: 'flex',
                                    alignItems: 'center',
                                    height: '14px',
                                    '.css-ahj2mt-MuiTypography-root': {
                                      fontSize: '12px',
                                      color: 'input.font',
                                    },
                                    '.css-1n70hd2-MuiButtonBase-root-MuiRadio-root': {
                                      padding: '0px',
                                      margin: '0px 5px',
                                    },
                                    '.css-1rfdfc4-MuiButtonBase-root-MuiRadio-root': {
                                      padding: '0px',
                                      margin: '0px 5px',
                                      color: 'input.border',
                                    },
                                    '.css-1rfdfc4-MuiButtonBase-root-MuiRadio-root.Mui-checked': {
                                      color: 'primary.main',
                                    },
                                  }}
                                >
                                  <Typography
                                    sx={{
                                      fontSize: '0.75em',
                                      letterSpacing: '0.00938em',
                                      position: 'absolute',
                                      top: '-10px',
                                      left: '9px',
                                      background: '#fff',
                                      padding: '0px 3px',
                                      color: state.errorStatus.cessType ? 'danger.main' : 'input.label',
                                    }}
                                  >
                                    GST compensation Cess Type
                                    {/* <span style={{ color: '#e55353' }}>*</span> */}
                                  </Typography>

                                  <RadioGroup
                                    row
                                    name="cessType"
                                    value={state.cessType}
                                    onChange={(e) => {
                                      const value = e.target.value;
                                      if (value === '') {
                                        setState((prev) => ({
                                          ...prev,
                                          cessType: value,
                                          errorStatus: { ...prev.errorStatus, cessType: true },
                                          errorFields: {
                                            ...prev.errorFields,
                                            cessType: 'Please Select GST Compensation Type',
                                          },
                                        }));
                                      } else {
                                        setState((prev) => ({
                                          ...prev,
                                          cessType: value,
                                          errorStatus: { ...prev.errorStatus, cessType: false },
                                          errorFields: { ...prev.errorFields, cessType: '' },
                                        }));
                                      }
                                    }}
                                  >
                                    <FormControlLabel
                                      value="Percentage"
                                      control={<Radio size="small" disableRipple />}
                                      label="Percentage"
                                    />
                                    <FormControlLabel value="Amount" control={<Radio size="small" />} label="Amount" />
                                  </RadioGroup>
                                </Box>

                                <Typography
                                  sx={{
                                    marginTop: '2px',
                                    marginLeft: '10px',
                                    marginBottom: '0px',
                                    fontSize: '11px',
                                    color: 'danger.main',
                                  }}
                                >
                                  {state.errorFields.cessType}
                                </Typography>
                              </Box>

                              <Box sx={{ flex: { xs: 1, sm: 0.5, lg: 0.3 }, m: 1 }}>
                                <TextField
                                  error={state.errorStatus.cess == true ? true : false}
                                  label="Cess"
                                  name="cess"
                                  id="Cess"
                                  value={state.cess}
                                  fullWidth
                                  onChange={(e) => {
                                    const value = e.target.value;

                                    const regex = /^\d*\.?\d{0,2}$/;

                                    if (value === '' || regex.test(value)) {
                                      setState((prev) => ({
                                        ...prev,
                                        cess: value,
                                      }));
                                    }
                                  }}
                                  size="small"
                                  InputProps={{
                                    startAdornment: (
                                      <InputAdornment position="start">{state.cessType == 'Percentage' ? '%' : '₹'}</InputAdornment>
                                    ),
                                  }}
                                  sx={{
                                    '.css-wgai2y-MuiFormLabel-asterisk': {
                                      color: 'danger.main',
                                    },
                                  }}
                                />
                                <Typography
                                  sx={{
                                    marginTop: '2px',
                                    marginLeft: '10px',
                                    marginBottom: '0px',
                                    fontSize: '11px',
                                    color: 'danger.main',
                                  }}
                                >
                                  {state?.errorFields.cess}
                                </Typography>
                              </Box>
                            </>
                          )}
                        </Box>
                      )}
                    </AccordionDetails>
                  </Accordion>
                )}
            </Box>

            <Box
              sx={{
                display: 'flex',
                justifyContent: 'space-between',
                flexDirection: { xs: 'column', sm: 'row' },
              }}
            >
              <Button onClick={handleClose} variant="outlined" sx={{ flex: 1, margin: '10px', fontSize: '12px' }}>
                Cancel
              </Button>
              <LoadingButton
                loading={loading}
                disableRipple={true}
                onClick={saveChanges}
                variant="contained"
                sx={{ flex: 1, margin: '10px', fontSize: '12px' }}
              >
                ADD
              </LoadingButton>
            </Box>
          </Paper>
        </Fade>
      </Modal>
      {openHsnModal === true && (
        <AddHSNModal
          open={openHsnModal}
          setOpen={setOpenHsnModal}
          setData={setState}
          data={state}
          setFilterHSN={setFilterHSN}
          filteredHSN={filterHSN}
          searchHSNSAC={() => searchHSNDetails('', 0, 20)}
          hsnParamsID={hsnParamsID}
          itemType={'ledger'}
          page={'Invoice1'}
        />
      )}
      <AddBankAccountModal
        open={openBankAccountModal}
        setOpen={setOpenBankAccountModal}
        setData={setData}
        companyData={companyData}
        data={state}
        accountType={'ledgerAccount'}
        setAllAccount={setAllAccount}
        updatetedTableRow={updatetedTableRow}
        rowIndex={rowIndex}
        Type={Type}
        closeAccountModal={() => handleClose()}
      />
      <AddNewPartyModal
        open={openPartyModal}
        setOpen={setOpenPartyModal}
        partyType={selelctedGroupId === 7 ? 'supplier' : selelctedGroupId === 15 ? 'customer' : 'Add Party'}
        setNewPartyID={setNewPartyID}
        partyParamsID={''}
        Type={'Accounts'}
        newPartyName={newPartyName}
        setNewPartyName={setNewPartyName}
      />
      <GroupModal open={openGroupModal}
       onClose={()=>setOpenGroupModal(false)}
       parentGroupOptions={group}
       onSave={(newValue)=>handleGroupChanges(newValue)}
      />
    </Box>
  );
}

export default AddAccountModal;
